import { ChangeDetectionStrategy,Component, HostListener} from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-com-pr-orders-account-group-cell',
  templateUrl: './com-pr-orders-account-groupcell.component.html',
  styleUrls: ['./com-pr-orders-account-groupcell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrOrdersAccountGroupcellComponent  {
  params: any = {};
  parentComponent:any;
  rebalAcctDto: any = null;

  constructor(){

  }
  agInit(params: any): void {
    this.params = params;
    this.parentComponent = params.innerRendererParams.parentComponent;
  }
  refresh(): boolean {
    return true;
  }
  @HostListener('mouseover')
  getAccountToolTipDetails() {
    if(!this.rebalAcctDto && this.parentComponent && this.parentComponent.originalData
        && this.parentComponent.originalData.accRebalDTOList
        && this.parentComponent.originalData.accRebalDTOList.length > 0) {
      this.rebalAcctDto = this.parentComponent.originalData.accRebalDTOList.find((x:any)=>x.accountNum == this.params?.value);
    }
  }

}
